import { Component, ViewChild, ElementRef } from '@angular/core';
import { HttpResponse, HttpEventType } from '@angular/common/http';
import { DebriefingSAPOService } from './debriefingsapo.service';
import { ConfirmService } from '../shared/confirm/confirm.service';
import { AppService } from '../app.service';
import { Location } from '@angular/common';
import { FileUploader, FileLikeObject } from 'ng2-file-upload';
import { Globals } from '../globals';
import translateJson from "../../translate.json";
import customerJson from "../../assets/config/customer.json";
import { AuthenticationService } from '../auth';


@Component({
    selector: 'debriefingsapo-comp',
    providers: [DebriefingSAPOService, ConfirmService, AppService, AuthenticationService], 
    templateUrl: './debriefingsapo.component.html',  
    styleUrls: ['./debriefingsapo.component.css']  
})

export class DebriefingSAPOComponent {
  
  @ViewChild('selectExelFile') selectExelFileVar: ElementRef;
  
    public uploader: FileUploader = new FileUploader({allowedFileType: ["xlsx"]});

    // Get translation/text from customerJson
    private i18 = translateJson.i18;

    private edition = customerJson.edition;

    selectedFiles: FileList;
    currentFileUpload: File;
    error: String;

    private activeComponent: boolean;
    showLoader:boolean = false;

    constructor(
        private service: DebriefingSAPOService,          
        private confirmService: ConfirmService,
        private appService: AppService,
        private globals: Globals,
        private authService: AuthenticationService) {
          this.authService.isAuthenticated();
          this.activeComponent = appService.isComponentActive('debriefingsapo');
        }
    /*
    * Called when a file has been selected for upload
    * @param event the event containing the file
    */
    selectFile(event) {
        this.selectedFiles = event.target.files;
    }
    
    /*
    * Uploads the excel file and starts respone process
    */
    upload() {
      this.currentFileUpload = this.selectedFiles.item(0);
      this.showLoader = true;
      this.service.uploadFile(this.currentFileUpload, this.edition).subscribe(
        data => {
          if(data instanceof HttpResponse){
            this.startExcelDownload(data);
          }
        },
        error => this.showError(error)
      )
      this.selectExelFileVar.nativeElement.value = '';
      this.selectedFiles = undefined;
      
    }
    
    /*
    * Downloads the response excel file
    * @param data the response from the upload
    */
    startExcelDownload(data){
      this.service.getExcelStream(data.body.id, data.body.type).subscribe(
        data => {
          this.startExcelStreamDownload(data, "Avstämnings lista")
        },
        error => this.showError(error)
      );
    }
    
    /*
    * Pops a save as window
    * @param data the excel file
    * @param filename the default save name for the excel file 
    */
    startExcelStreamDownload(data, fileName) {
      if(window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveBlob(data, fileName + ".xlsx");
      } else {
        const url = window.URL.createObjectURL(data);
        const anchor = document.createElement("a");
        anchor.href = url;
        anchor.download = fileName + ".xlsx";
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
      }
      this.showLoader = false;
    }

    /**
     * Fetch the debriefing template from backend. Since the responsetype is a blob we cant fetch the error message
     */
    getDebriefTemplate() {  
      this.showLoader = true;    
      this.service.getDebriefTemplate().subscribe(
          data => { this.startExcelStreamDownload(data, "Mall - Avstämningslista")
        },
        async error => {
          this.showError(error)
        }

      )
    }
    
    /*
    * Pops the error modal
    */
    showError(error) {
      this.showLoader = false;
      this.confirmService.error(this.appService.getTranslatedErrorMessage(error));
      this.selectExelFileVar.nativeElement.value = '';
      this.selectedFiles = undefined;
      this.currentFileUpload = undefined;
      
    }
}
